var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { Button, Pane, MenuSection, MessageBanner, IconButton, ConfirmationModal, ErrorModal, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import PublisherDetail from "../publishers/PublisherDetail";
import { AddRegistrationDialog } from "../publishers/PublisherDetail/AddRegistrationDialog";
import { updatePublisherAction } from "../../api/publisherService";
import { publisherActionMessageId } from "../../utils/publisherActionError";
import { hasAtLeastOneRole, useActiveRoles, } from "../../utils/permissionsUtils";
import { usePermissions } from "../../hooks/usePermissions";
import { REGISTRATION_AGENCIES, hasActiveRegistrationAtAgency, } from "../../utils/registrationUtils";
import { RoleEnum } from "../../types/RoleEnum";
import { fetchCurrentUser } from "../../api/userService";
import { useInvalidatePublisher, usePublisherQuery, } from "../../hooks/usePublisherQuery";
import NavComponent from "../../components/NavComponent";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { fetchOpenSubmittedUpdateRequest, fetchPublisherUpdateRequests, } from "../../api/publisherUpdateRequestService";
import { isDataConfirmationExpired as computeDataConfirmationExpired, resolvePublisherWarning, } from "../../utils/publisherWarning";
var MyPublisherDetail = function () {
    var _a;
    var history = useHistory();
    var ky = useOkapiKy();
    var activeRoles = useActiveRoles().roles;
    var canAddPublisherRegistration = usePermissions().canAddPublisherRegistration;
    var formatMessage = useIntl().formatMessage;
    var invalidatePublisher = useInvalidatePublisher();
    var _b = useState(true), filterPaneIsVisible = _b[0], setFilterPaneIsVisible = _b[1];
    var _c = useState(false), errorModalOpen = _c[0], setErrorModalOpen = _c[1];
    var _d = useState(null), actionError = _d[0], setActionError = _d[1];
    var _e = useState(false), showConfirmModal = _e[0], setShowConfirmModal = _e[1];
    var _f = useState(null), confirmAction = _f[0], setConfirmAction = _f[1];
    var _g = useState(null), confirmMessage = _g[0], setConfirmMessage = _g[1];
    var _h = useState(), warningMessage = _h[0], setWarningMessage = _h[1];
    var _j = useState(false), warningMessageShow = _j[0], setWarningMessageShow = _j[1];
    var _k = useState(null), registrationAgency = _k[0], setRegistrationAgency = _k[1];
    var _l = useState(false), registrationSuccessShow = _l[0], setRegistrationSuccessShow = _l[1];
    var _m = useState(false), conversionSuccessShow = _m[0], setConversionSuccessShow = _m[1];
    var currentUser = useQuery("currentUser", function () {
        return fetchCurrentUser(ky);
    }).data;
    var publisherId = (_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.activeOrganization) === null || _a === void 0 ? void 0 : _a.sourceId;
    var selectedPublisher = usePublisherQuery(publisherId).data;
    // DB-133: the warning must not be evaluated until both the current user and
    // the publisher have loaded — otherwise `dataConfirmationExpired` (which
    // defaults to true while `selectedPublisher` is undefined) makes the warning
    // banner flash on every entry into the module (queries use staleTime: 0).
    var dataLoaded = !!currentUser && !!selectedPublisher;
    var isDataConfirmationExpired = useMemo(function () { return computeDataConfirmationExpired(selectedPublisher === null || selectedPublisher === void 0 ? void 0 : selectedPublisher.dataConfirmationTime); }, [selectedPublisher === null || selectedPublisher === void 0 ? void 0 : selectedPublisher.dataConfirmationTime]);
    // An open SUBMITTED update request means the publisher has already sent changes for
    // approval. In that state we must NOT re-open the data-confirmation prompt (the edit
    // already counts as a confirmation) — we show a single, clear "pending approval"
    // banner instead of stacking the confirmation prompt on top of the wait message.
    var openSubmittedRequest = useQuery(["openSubmittedUpdateRequest", selectedPublisher === null || selectedPublisher === void 0 ? void 0 : selectedPublisher.id], function () { return fetchOpenSubmittedUpdateRequest(ky, selectedPublisher.id); }, { enabled: !!(selectedPublisher === null || selectedPublisher === void 0 ? void 0 : selectedPublisher.id), retry: false }).data;
    var hasOpenSubmittedRequest = !!openSubmittedRequest;
    useEffect(function () {
        var warning = resolvePublisherWarning({
            dataLoaded: dataLoaded,
            hasOpenSubmittedRequest: hasOpenSubmittedRequest,
            dataConfirmationExpired: isDataConfirmationExpired,
        });
        if (warning.messageId) {
            setWarningMessage(formatMessage({ id: warning.messageId }));
        }
        setWarningMessageShow(warning.show);
        setErrorModalOpen(warning.errorModalOpen);
    }, [
        dataLoaded,
        hasOpenSubmittedRequest,
        isDataConfirmationExpired,
        formatMessage,
    ]);
    var handleConfirmData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selectedPublisher) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, updatePublisherAction(ky, selectedPublisher.id, "confirmData")];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, invalidatePublisher(selectedPublisher.id)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    console.error("Error confirming publisher:", error_1);
                    // RECEK-76282: the failure is shown, e.g. the refusal of another publisher than the own one
                    setActionError(formatMessage({
                        id: publisherActionMessageId(error_1, "ui-br-publishers.publishers.error.confirmData"),
                    }));
                    // the confirmation dialog reports the failure instead of a success
                    throw error_1;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleRegistrationConverted = useCallback(function () { return setConversionSuccessShow(true); }, []);
    var onChangeButton = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetchPublisherUpdateRequests(ky, {
                            status: "SUBMITTED",
                            publisherId: selectedPublisher === null || selectedPublisher === void 0 ? void 0 : selectedPublisher.id,
                        })];
                case 1:
                    data = _a.sent();
                    if (data.totalRecords > 0) {
                        setWarningMessage(formatMessage({
                            id: "ui-br-publishers.publishers.update.request.exists.message",
                        }));
                        setWarningMessageShow(true);
                    }
                    else {
                        history.push("/brpublishers/my-publisher/edit/".concat(selectedPublisher === null || selectedPublisher === void 0 ? void 0 : selectedPublisher.id));
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    console.error("Error fetching publisher update requests:", error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var hasRoleAndIsNotClosed = function (roles) {
        return (hasAtLeastOneRole(activeRoles, roles) &&
            (selectedPublisher === null || selectedPublisher === void 0 ? void 0 : selectedPublisher.status) !== "CLOSED");
    };
    var toggleFilterPane = function () { return setFilterPaneIsVisible(function (prev) { return !prev; }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(RecekPaneSet, null,
            filterPaneIsVisible && (React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({
                    id: "ui-br-publishers.my-publisher.pane.title.navigation",
                }), lastMenu: filterPaneIsVisible ? (React.createElement(IconButton, { icon: "caret-left", onClick: toggleFilterPane, "aria-label": filterPaneIsVisible
                        ? formatMessage({
                            id: "ui-br-publishers.my-publisher.iconButton.ariaLabel.hideFilters",
                        })
                        : formatMessage({
                            id: "ui-br-publishers.my-publisher.iconButton.ariaLabel.showFilters",
                        }), style: { marginLeft: "auto" } })) : (React.createElement(React.Fragment, null)) },
                React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                    React.createElement(NavComponent, null)))),
            React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: React.createElement(FormattedMessage, { id: "ui-br-publishers.my-publisher.pane.title" }), actionMenu: function () { return (React.createElement(MenuSection, { label: formatMessage({
                        id: "ui-br-publishers.my-publisher.pane.actionMenu.menuSelection.label.action",
                    }), id: "actions-menu" },
                    hasAtLeastOneRole(activeRoles, [
                        RoleEnum.PUBLISHER_ADMIN,
                        RoleEnum.PUBLISHER_GUARANTOR,
                    ]) && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () { return onChangeButton(); } },
                        React.createElement(FormattedMessage, { id: "stripes-core.button.edit" }))),
                    hasAtLeastOneRole(activeRoles, [
                        RoleEnum.PUBLISHER_ADMIN,
                        RoleEnum.PUBLISHER_GUARANTOR,
                    ]) && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                            setConfirmAction(function () { return handleConfirmData; });
                            setShowConfirmModal(true);
                        } },
                        React.createElement(FormattedMessage, { id: "ui-br-publishers.my-publisher.button.confirm.data" }))),
                    hasRoleAndIsNotClosed([
                        RoleEnum.PUBLISHER_ADMIN,
                        RoleEnum.PUBLISHER_GUARANTOR,
                    ]) && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                            return history.push("/brpublishers/my-publisher/close/".concat(selectedPublisher === null || selectedPublisher === void 0 ? void 0 : selectedPublisher.id));
                        } },
                        React.createElement(FormattedMessage, { id: "ui-br-publishers.my-publisher.button.close.publisher" }))),
                    canAddPublisherRegistration &&
                        selectedPublisher &&
                        REGISTRATION_AGENCIES.filter(function (agency) {
                            return !hasActiveRegistrationAtAgency(selectedPublisher, agency);
                        }).map(function (agency) { return (React.createElement(Button, { key: agency, buttonStyle: "dropdownItem", onClick: function () { return setRegistrationAgency(agency); } }, formatMessage({
                            id: "ui-br-publishers.publishers.menu.label.registerAgency",
                        }, { agency: agency }))); }))); }, firstMenu: !filterPaneIsVisible ? (React.createElement(IconButton, { icon: "caret-right", onClick: toggleFilterPane, "aria-label": filterPaneIsVisible
                        ? formatMessage({
                            id: "ui-br-publishers.my-publisher.iconButton.ariaLabel.hideFilters",
                        })
                        : formatMessage({
                            id: "ui-br-publishers.my-publisher.iconButton.ariaLabel.showFilters",
                        }), style: { marginLeft: "auto" } })) : (React.createElement(React.Fragment, null)) },
                React.createElement(MessageBanner, { autoFocusDismissButton: true, dismissible: true, onExited: function () { return setActionError(null); }, show: actionError !== null, type: "error" }, actionError),
                React.createElement(MessageBanner, { autoFocusDismissButton: true, dismissible: true, onExited: function () { return setWarningMessageShow(false); }, show: warningMessageShow, type: "warning" }, warningMessage),
                React.createElement(MessageBanner, { autoFocusDismissButton: true, dismissible: true, onExited: function () { return setRegistrationSuccessShow(false); }, show: registrationSuccessShow, type: "success" }, formatMessage({
                    id: "ui-br-publishers.publishers.registrations.success.registered",
                })),
                React.createElement(MessageBanner, { autoFocusDismissButton: true, dismissible: true, onExited: function () { return setConversionSuccessShow(false); }, show: conversionSuccessShow, type: "success" }, formatMessage({
                    id: "ui-br-publishers.publishers.registrations.success.converted",
                })),
                selectedPublisher && (React.createElement(PublisherDetail, { key: selectedPublisher.id, publisher: selectedPublisher, showKult1801Report: true, ownPublisher: true, onRegistrationConverted: handleRegistrationConverted })))),
        React.createElement(AddRegistrationDialog, { open: !!registrationAgency, publisherId: selectedPublisher === null || selectedPublisher === void 0 ? void 0 : selectedPublisher.id, preselectedAgency: registrationAgency !== null && registrationAgency !== void 0 ? registrationAgency : undefined, alreadyExistsMessageId: "ui-br-publishers.my-publisher.registrations.error.alreadyExists", onClose: function () { return setRegistrationAgency(null); }, onSuccess: function (updatedPublisher) {
                setRegistrationAgency(null);
                setRegistrationSuccessShow(true);
                invalidatePublisher(updatedPublisher.id);
            } }),
        React.createElement(ErrorModal, { open: errorModalOpen, label: formatMessage({
                id: "ui-br-publishers.my-publisher.warning.title",
            }), content: formatMessage({
                id: "ui-br-publishers.my-publisher.warning.message",
            }), onClose: function () { return setErrorModalOpen(false); } }),
        showConfirmModal && (React.createElement(ConfirmationModal, { open: showConfirmModal, heading: formatMessage({
                id: "ui-br-publishers.my-publisher.button.confirm.data",
            }), message: confirmMessage ||
                formatMessage({
                    id: "ui-br-publishers.my-publisher.modal.confirm.message",
                }), onConfirm: confirmMessage
                ? function () { return setShowConfirmModal(false); }
                : function () { return __awaiter(void 0, void 0, void 0, function () {
                    var error_3;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!confirmAction) return [3 /*break*/, 4];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, confirmAction()];
                            case 2:
                                _a.sent();
                                setConfirmMessage(formatMessage({
                                    id: "ui-br-publishers.messages.action.success",
                                }));
                                return [3 /*break*/, 4];
                            case 3:
                                error_3 = _a.sent();
                                console.error("Error performing action:", error_3);
                                setConfirmMessage(formatMessage({
                                    id: "ui-br-publishers.messages.action.error",
                                }));
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                }); }, onCancel: function () { return setShowConfirmModal(false); }, confirmLabel: confirmMessage
                ? formatMessage({ id: "ui-br-publishers.button.ok" })
                : formatMessage({ id: "ui-br-publishers.button.yes" }), cancelLabel: !confirmMessage &&
                formatMessage({ id: "ui-br-publishers.button.no" }), buttonStyle: "primary" }))));
};
export default MyPublisherDetail;
